import { useFormContext } from "react-hook-form"
import { t } from "i18next"
import { FormField } from "@/components/ui/form"
import { Input, TextArea } from "@/components/ui/input"
import { PregnantForm } from "@/modules/patients/detail/health-information/gynaecology/pregnant-form"
import { GynaecologyForm } from "@/modules/patients/schema/gynaecology-form-schema"

const regexYearNum = /^\d{0,4}$/

const GynaecologyEditableBody = () => {
  const form = useFormContext<GynaecologyForm>()
  const {
    register,
    control,
    setValue,
    formState: { errors: formErrors },
  } = form

  const onFirstPeriodChange = (value: string) => {
    if (!regexYearNum.test(value)) {
      return
    }
    setValue("firstPeriod", value, { shouldDirty: true, shouldValidate: true })
  }

  const onMenopauseSinceChange = (value: string) => {
    if (!regexYearNum.test(value)) {
      return
    }
    setValue("menopauseSince", value, { shouldDirty: true, shouldValidate: true })
  }

  return (
    <div className="grid grid-cols-4 gap-4">
      <div className="col-span-2">
        <FormField
          name="firstPeriod"
          control={control}
          render={({ field: { value } }) => {
            return (
              <Input
                onChange={(e) => {
                  onFirstPeriodChange(e.target.value)
                }}
                value={value ?? ""}
                label={t("patient.healthInformation.gynaecology.form.firstPeriod")}
                error={formErrors.firstPeriod?.message}
                translateError
                type="text"
                testId="first-period"></Input>
            )
          }}
        />
      </div>
      <div className="col-span-2">
        <FormField
          name="menopauseSince"
          control={control}
          render={({ field: { value } }) => {
            return (
              <Input
                onChange={(e) => {
                  onMenopauseSinceChange(e.target.value)
                }}
                value={value ?? ""}
                label={t("patient.healthInformation.gynaecology.form.menopauseSince")}
                error={formErrors.menopauseSince?.message}
                translateError
                errorClasses="truncate"
                type="text"
                testId="menopause-since"></Input>
            )
          }}
        />
      </div>

      <PregnantForm />

      <div className="col-span-4">
        <TextArea
          {...register("pregnancyHistory")}
          label={t("patient.healthInformation.gynaecology.form.pregnancyHistory")}
          error={formErrors.pregnancyHistory?.message}
          translateError
          errorClasses="truncate"
          data-testid="pregnancy-history"
        />
      </div>
    </div>
  )
}

export { GynaecologyEditableBody }
